export default "__VITE_ASSET__BjaaxSdn__"